module.exports = __webpack_public_path__ + "img/graphene.ef84f471.png";